import {evaluateExperimentAndLog} from '@homeaway/abacus-client-utils';

/**
 * Ensures the test exposure is fired only once.
 * @example
 * const testExposure = new TestExposureOnce('ha_pulse_test_name');
 * testExposure.trigger();
 */

export default class TestExposureOnce {
    constructor(experimentName) {
        this.isLogged = false;
        this.name = experimentName;
    }

    trigger() {
        // only log test exposure once
        if (!this.isLogged) {
            evaluateExperimentAndLog(this.name);
            this.isLogged = true;
        }
    }
}
